/**
 * Protected Route Component
 * Wraps components that require authentication
 */

import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, fallback = null }) => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="container">
        <div className="loading">
          <h2>Loading...</h2>
          <p>Verifying authentication...</p>
        </div>
      </div>
    );
  }

  // If not authenticated, show fallback or redirect to login
  if (!isAuthenticated) {
    return fallback || (
      <div className="container">
        <div className="login-container">
          <h1>Authentication Required</h1>
          <p>Please log in to access this page.</p>
        </div>
      </div>
    );
  }

  // If authenticated, render the protected content
  return children;
};

export default ProtectedRoute;
